import React from "react";
import { Link } from "react-router-dom";
import "./CommitteeCoordinators.css";
import { Table } from "react-bootstrap";
import { Box, Button, Container, Grid, Paper, TableBody, TableCell, TableContainer, TableHead, TableRow, Typography } from "@mui/material";
import templeJson from "../../config/temple.json";
import { styled } from "@mui/material/styles";

function CommitteeCoordinators() {
  const trusteeData = [
    { committee: "BAL GOKULUM", members: ["Kusum Taneja", "Madhuri Prasad", "Saurabh Thakrar"] },
    { committee: "BHANDARA & KITCHEN", members: ["Darshna Thakral", "Anu Agarwal", "Amol & Manjeet Sharma"] },
    { committee: "CULTURAL ACTIVITIES", members: ["Mini Pillai", "Kamini Patel", "Monika Chopra"] },
    { committee: "DECORATIONS", members: ["Sarada Sistla", "Rupa Patel", "Madhvi"] },
    { committee: "EDUCATION - HINDUISM", members: ["Sampath Vanamamalai", "Sai Ramana", "Valadi Kannan"] },
    { committee: "FACILITY RENTALS", members: ["Mahendra Chudasama", "Naveen Gupta", "Praful Patel"] },
    { committee: "FINANCE & ACCOUNTING", members: ["Madan Gupta", "Mini Pillai", "Poonam Bansal"] },
    { committee: "FLYERS", members: ["Sarada Sistla", "Sai Ramana", "Sangeeta"] },
    { committee: "FUNDRAISING", members: ["Karuna Gulati", "Monika Chopra", "Sapna Rohatgi"] },
    { committee: "GITA DISCOURSE", members: ["Jay Kalathil", "B. K. Kishore", "Kamal Bhatt"] },
    { committee: "HEALTH CLINIC", members: ["Madan Gupta", "Kusum Taneja", "Manju Sangraula"] },
    { committee: "HUMAN RESOURCES", members: ["Mahendra Chudasama", "Ranjna Sachdeva", "Niranjan Adhikari"] },
    { committee: "FLOWERS & MALA", members: ["Vani", "Rashmi", "Yogita Shah"] },
    { committee: "IT - INTERNET & NETWORK", members: ["Naveen Gupta", "Saurabh Thakrar", "Hetul Patel"] },
    { committee: "INTERFAITH/INTERCULTURAL DIVERSITY", members: ["Chander Sharma", "Valadi Kannan", "Romal Patel"] },
    { committee: "JAGRAN & MATA KI CHOWKI", members: ["Raj Garg", "Karuna Gulati", "Sudhir Oberoi"] },
    { committee: "MAINTENANCE & UPKEEP", members: ["Raj Kapoor", "Pankaj Wadhwa", "Chander Sharma"] },
    { committee: "NEWSLETTER", members: ["Sai Ramana", "Ashwini Lata", "Sakshi Sharma"] },
    { committee: "PARKING ACCOMMODATIONS", members: ["Himanshu Patel", "Mitesh Patel", "Manish Shah"] },
    { committee: "RELIGIOUS ACTIVITIES", members: ["Sarada Sistla", "Mahendra Chudasama", "Rohit Vashist"] },
    { committee: "SAT & TJ SCHOOL PREP.", members: ["Archana Vardhan", "Monika Chopra", "Meena Srinivas"] },
    { committee: "SAFETY & SECURITY", members: ["Mahendra Chudasama", "Raj Kapoor", "Vinay Narang"] },
    { committee: "SENIOR CITIZENS", members: ["Sapna Rohatgi", "Karuna Gulati", "Madhulika Sharma"] },
    { committee: "SOCIAL MEDIA", members: ["Mini Pillai", "Ashwini Lata", "Gaurav Sharma"] },
    { committee: "SOUND SYSTEMS", members: ["Devang Patel", "Saurabh Thakrar", "Bhusan Desai"] },
    { committee: "VENDOR COORDINATOR", members: ["Mahendra Chudasama", "Rupa Patel", "Sejal Soni"] },
    { committee: "VOLUNTEER COORDINATOR", members: ["Sarada Sistla", "Bhusan Desai", "Rupa Patel"] },
    { committee: "WEBSITE ADMINISTRATOR", members: ["Mahendra Chudasama", "Ranjna Sachdeva", "Bhusan Desai"] },
    { committee: "YOGA SADHANA", members: ["Jay Kalathil", "Dhananjay Shevlikar", "Shaishav Shah"] },
    { committee: "YOUTH OUTREACH", members: ["Anu Agarwal", "Suniti Sharma", "Sakshi Sharma"] },
    { committee: "PHOTOS & VIDEOS", members: ["Dhaval & Dishant Shah", "Ashwini Lata", "Rajesh Khatri"] },
  ];
  const HeaderCell = styled(TableCell)(({ theme }) => ({
    backgroundColor: "white !important",
    color: "#000000 !important",
    fontWeight: "bold !important",
    padding: "10px !important",
    borderBottom: "1px solid #ddd !important",
    textAlign: "left !important",
  }));
  
  const StyledTableRow = styled(TableRow, {
    shouldForwardProp: (prop) => prop !== 'index',
  })(({ index, theme }) => ({
    backgroundColor: index % 2 === 0 ? '#f9f9f9' : '#ffffff',
    '&:hover': {
      backgroundColor: '#e6f7ff',
    },
    '& td, & th': {
      backgroundColor: 'inherit !important',
    },
  }));
  
  // Updated regular table cells
  const StyledTableCell = styled(TableCell)(({ theme }) => ({
    padding: "10px !important",
    borderBottom: "1px solid #ddd !important",
    fontSize: "14px !important",
  }));

  
  return (
    <>
      <Container maxWidth={'xl'} className="page-header py-4 breadcrumb-bg">
        <h1 className="text-center display-6 breadcrumb-h1">
          Temple Committee Coordinators
        </h1>
        <ul className="breadcrumb justify-content-center mb-0">
          <li className="breadcrumb-item">
            <Link to="/">Home</Link>
          </li>
          <li className="breadcrumb-item">
            <Link to="/">About Us</Link>
          </li>
          <li className="breadcrumb-item active">
            Temple Committee Coordinators
          </li>
        </ul>
      </Container>

      <Container className=" py-5">
        <Grid className="text-center mb-5">
          <h6 className="section-title text-center text-primary text-uppercase title-tl">
            Temple
          </h6>
          <h1 className="mb-3">
            <span className="text-secundary">Committee Coordinators</span>
          </h1>
        </Grid>
        <Grid container spacing={2}>
          {/* Buttons */}
          <Grid item xs={12}>
            <Box mb={4} textAlign="right">
              <Button variant="contained" color="success" className="me-3">
                Previous Year
              </Button>
              <Button variant="contained">Next Year</Button>
            </Box>
          </Grid>

          {/* Contact Paragraph */}
          <Grid item xs={12}>
            <Typography component="p">
              You can contact trustees or Exec committee or Committee members by email as{" "}
              <a href={templeJson.infoEmail}>{templeJson.infoEmail}</a> or at the temple phone{" "}
              <a href="tel:703-690-9355">703-690-9355</a>
            </Typography>
          </Grid>

          {/* Trustee Table */}
          <Grid item xs={12}>
            <TableContainer component={Paper} elevation={3} sx={{ borderRadius: "0", overflow: "hidden",boxShadow:'none !important' }}>
                <Table sx={{ minWidth: 650 }} border={1}>
                  <TableHead>
                    <TableRow>
                      <HeaderCell>Committee Name</HeaderCell>
                      <HeaderCell>Member</HeaderCell>
                      <HeaderCell>Member</HeaderCell>
                      <HeaderCell>Member</HeaderCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                    {trusteeData.map(({ committee, members }, index) => (
                      <StyledTableRow key={committee} index={index}>
                        <StyledTableCell 
                          component="th" 
                          scope="row"
                          sx={{ fontWeight: "500" }}
                        >
                          {committee}
                        </StyledTableCell>
                        {members.map((member, idx) => (
                          <StyledTableCell key={idx}>{member}</StyledTableCell>
                        ))}
                      </StyledTableRow>
                    ))}
                  </TableBody>
                </Table>
            </TableContainer>
          </Grid>
        </Grid>
      </Container>
    </>
  );
}

export default CommitteeCoordinators;
